import { createReducer } from '@reduxjs/toolkit';

import { resetArticlesFilter, setArticlesFilter } from '../../actions/articles/articlesFilter';

const initialState = {
  page: 1,
  size: 15,
  order: undefined,
  query: undefined,
  articlesStatus: undefined,
  articlesMarket: undefined,
};

const articlesFilterReducer = createReducer(initialState, {
  [setArticlesFilter]: (state, { payload }) => ({
    ...state,
    ...payload
  }),
  [resetArticlesFilter]: () => initialState
});

export default articlesFilterReducer;
